module.exports = __webpack_public_path__ + "static/playbook-logo-ae937e5b32a76e487cce79f3c5135a2d.png";